import { observer } from "mobx-react";
import { Canvas } from "@react-three/fiber";
import { OverviewCameraController, MapCameraController } from "./camera-controller";
import { Obstacles, PathLines, WarehouseFloor, WarehouseZones } from "./warehouse";
import { store } from "../../store";
import { AgvFleet } from "./agv";
import { Box, Grid2X2, Minus, Plus } from "lucide-react";
import { useGlobalBus } from "../hooks/use-global-bus";
import { Button } from "@/components/ui/button";

const SceneContent = (): JSX.Element => {
    return (
        <>
            <ambientLight intensity={4} />
            <directionalLight position={[10, 20, 10]} intensity={2} />
            <WarehouseFloor />
            <WarehouseZones />
            <Obstacles />
            <PathLines />
            <AgvFleet />
        </>
    );
};

const BACKGROUND_COLOR = "#f3f4f6";

export const Scene = observer((): JSX.Element => {
    const { viewMode } = store.serviceAgv;
    const globalBus = useGlobalBus();

    return (
        <div className="relative min-w-0 flex-1">
            {viewMode === "3d" ? (
                <Canvas
                    key="3d"
                    camera={{
                        position: [0, 30, 30],
                        fov: 50,
                        near: 0.1,
                        far: 200,
                    }}
                    style={{ background: BACKGROUND_COLOR }}
                >
                    <SceneContent />
                    <OverviewCameraController />
                </Canvas>
            ) : (
                <Canvas
                    key="2d"
                    orthographic
                    camera={{
                        position: [0, 50, 0],
                        zoom: 20,
                        near: 0.1,
                        far: 200,
                    }}
                    style={{ background: BACKGROUND_COLOR }}
                >
                    <SceneContent />
                    <MapCameraController />
                </Canvas>
            )}
            <Button
                variant="outline"
                onClick={store.serviceAgv.toggleViewMode}
                className="absolute top-4 right-4 p-3"
            >
                {viewMode === "3d" ? (
                    <>
                        <Grid2X2 size={16} />
                        2D
                    </>
                ) : (
                    <>
                        <Box size={16} />
                        3D
                    </>
                )}
            </Button>
            <Button
                onClick={() => globalBus.emit("zoom_in")}
                variant="outline"
                className="absolute bottom-16 left-4 h-10 w-10"
            >
                <Plus size={16} />
            </Button>
            <Button
                onClick={() => globalBus.emit("zoom_out")}
                variant="outline"
                className="absolute bottom-4 left-4 h-10 w-10"
            >
                <Minus size={16} />
            </Button>
        </div>
    );
});
